import React, { useRef, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import InformationCard from "../../../components/User/InfoCards/2BedInfoCard";
import styles from "./2BedroomPage.module.css";

const slides = ["/images/slide1.jpg", "/images/slide2.jpg", "/images/slide3.jpg"];

const TwoBedroomPage = () => {
  const location = useLocation();
  const cardRef = useRef(null);
  const stopRef = useRef(null);
  const sliderRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  // Handle affiliate code preservation
  useEffect(() => {
    try {
      const sp = new URLSearchParams(location.search || "");
      const code = sp.get("aff") || sp.get("affiliate") || sp.get("ref") || sp.get("code");
      if (code) {
        // Store the affiliate code so InformationCard can access it
        localStorage.setItem("affiliate_code", code);
      }
    } catch {}
  }, [location.search]);

  useEffect(() => {
    const slider = sliderRef.current;

    const handleScroll = () => {
      const scrollLeft = slider.scrollLeft;
      const width = slider.offsetWidth;
      const index = Math.round(scrollLeft / width);
      setActiveIndex(index);
    };

    if (slider) {
      slider.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (slider) {
        slider.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <div>
      <div className={styles.roomLayout}>
        {/* Desktop stacked images */}
        <div className={`${styles.roomImages} ${styles.desktopImages}`}>
          {slides.map((slide, idx) => (
            <img key={idx} src={slide} alt={`Room view ${idx + 1}`} />
          ))}
        </div>

        {/* Mobile slider */}
        <div className={`${styles.roomImagesMobile} ${styles.mobileSlider}`} ref={sliderRef}>
          {slides.map((slide, idx) => (
            <img key={idx} src={slide} alt={`Room view ${idx + 1}`} />
          ))}
        </div>

        {/* Swiping dots indicator */}
        <div className={styles.sliderDots}>
          {slides.map((_, idx) => (
            <span
              key={idx}
              className={`${styles.dot}${idx === activeIndex ? ` ${styles.active}` : ''}`}
            />
          ))}
        </div>

        {/* Info card */}
        <div className={styles.roomCardWrapper} ref={cardRef}>
          <InformationCard />
        </div>
      </div>

      {/* Reviews section */}
      <div className={styles.roomReviews} ref={stopRef}>
        <blockquote>
          <p className={styles.roomReviewsParagraphs}>
            “Every detail at Aurelia exudes elegance. From the moment I arrived,
            I felt like royalty.”
          </p>
          <footer>- Sophia (Aurelia Resident)</footer>
        </blockquote>

        <blockquote>
          <p className={styles.roomReviewsParagraphs}>
            “Aurelia isn’t just a place—it’s an experience of pure refinement
            and perfection.”
          </p>
          <footer>- James (Aurelia Resident)</footer>
        </blockquote>

        <blockquote>
          <p className={styles.roomReviewsParagraphs}>
            “The level of sophistication and attention to detail is simply
            unmatched. Aurelia sets a new standard for luxury.”
          </p>
          <footer>- Sadiq (Aurelia Resident)</footer>
        </blockquote>
      </div>
    </div>
  );
};

export default TwoBedroomPage;
